import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Avatar, Rating, CircularProgress } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { urlImg } from '../../common/helpers';
import StarIcon from '@mui/icons-material/Star';
import { getServiceReviews } from '../../../actions/reviews';

moment.locale('es');

const ReviewCard = ({ review }) => {
  const cliente = review.cliente || {};
  const nombre = cliente.name ? `${cliente.name} ${cliente.apellido || ''}`.trim() : 'Usuario';
  const avatarSrc = cliente.avatar
    ? `${urlImg}/users/${cliente._id}/${cliente.avatar}?v=${cliente.versionAvatar || 0}`
    : null;

  return (
    <Card elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: '12px', backgroundColor: 'white', border: 1, borderColor: 'sutil', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Avatar src={avatarSrc} sx={{ width: 44, height: 44, bgcolor: 'primary.main', fontSize: '1rem' }}>
            {!avatarSrc && nombre.charAt(0)}
          </Avatar>
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" color="primary.main">{nombre}</Typography>
            <Typography variant="caption" color="text.secondary">
              hace {moment(review.createdAt).fromNow(true)}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Rating value={review.rating} readOnly size="small" sx={{ color: 'primary.main' }} />
          <Typography variant="subtitle2" fontWeight="bold" color="primary.main">{review.rating}</Typography>
        </Box>
      </Box>
      {review.comentario && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, lineHeight: 1.6 }}>
          {review.comentario}
        </Typography>
      )}
    </Card>
  );
};

// ratingPromedio: el promedio REAL del servicio (todas sus calificaciones, con o sin comentario)
const ServiceReviews = ({ servicioId, nombreProveedor, ratingPromedio }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!servicioId) return;
    setLoading(true);
    getServiceReviews(servicioId, { conComentario: true }).then((data) => {
      setReviews(data || []);
      setLoading(false);
    });
  }, [servicioId]);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 2 }}>
        <Box>
          <Typography variant="h5" fontWeight="bold" color="primary.main">
            Comentarios destacados
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {reviews.length > 0
              ? `${reviews.length} ${reviews.length === 1 ? 'comentario' : 'comentarios'} sobre ${nombreProveedor || 'este servicio'}`
              : `Comentarios sobre ${nombreProveedor || 'este servicio'}`}
          </Typography>
        </Box>
        {ratingPromedio > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <StarIcon sx={{ color: 'primary.main', fontSize: 24 }} />
            <Typography variant="h6" fontWeight="bold" color="primary.main">{Number(ratingPromedio).toFixed(1)}</Typography>
          </Box>
        )}
      </Box>

      {loading ? (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={28} sx={{ color: 'secondary.main' }} />
        </Box>
      ) : reviews.length === 0 ? (
        <Box sx={{ bgcolor: 'grey.50', borderRadius: '12px', p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Aún no hay comentarios para este servicio.
          </Typography>
        </Box>
      ) : (
        reviews.map((review) => <ReviewCard key={review._id} review={review} />)
      )}
    </Box>
  );
};

export default ServiceReviews;
